import { typeCreatorV2 } from '../../../redux/utils/common';

//  [REDUCER][TYPE]
export const SET_REGISTRATION_DETAIL: string = typeCreatorV2(
  'RegistrationDetailReducer',
  'SetRegistrationDetail'
);

export const SET_ALL_COUNTRIES: string = typeCreatorV2(
  'RegistrationDetailReducer',
  'SetAllCountries'
);

export const SET_MEMBER_STATE_COUNTRIES: string = typeCreatorV2(
  'RegistrationDetailReducer',
  'SetMemberStateCountries'
);

export const SET_NON_MEMBER_STATE_COUNTRIES: string = typeCreatorV2(
  'RegistrationDetailReducer',
  'SetNonMemberStateCountries'
);

export const SET_IMPORT_COUNTRIES: string = typeCreatorV2(
  'RegistrationDetailReducer',
  'SetImportCountries'
);

export const SET_COUNTRIES_EXCLUDE_CYPRUS: string = typeCreatorV2(
  'RegistrationDetailReducer',
  'SetCountriesExcludeCyprus'
);

export const SET_SCHEME_TYPES: string = typeCreatorV2(
  'RegistrationDetailReducer',
  'SetSchemeTypes'
);

export const SET_PREVIOUS_USE_OF_SPECIAL_SCHEME: string = typeCreatorV2(
  'RegistrationDetailReducer',
  'SetPreviousUseOfSpecialScheme'
);

export const SET_IDENTIFICATION_IN_OTHER_EU_COUNTRIES: string = typeCreatorV2(
  'RegistrationDetailReducer',
  'SetIdentificationInOtherEuCountries'
);

export const SET_FIX_ESTABLISHMENTS: string = typeCreatorV2(
  'RegistrationDetailReducer',
  'SetFixEstablishments'
);

export const TEMPORARY_SAVE_REGISTRATION: string = typeCreatorV2(
  'RegistrationDetailReducer',
  'TemporarySaveRegistration'
);

export const FINAL_SUBMIT_REGISTRATION: string = typeCreatorV2(
  'RegistrationDetailReducer',
  'FinalSubmitRegistration'
);

export const APPROVE_REGISTRATION: string = typeCreatorV2(
  'RegistrationDetailReducer',
  'ApproveRegistration'
);

export const REJECT_REGISTRATION: string = typeCreatorV2(
  'RegistrationDetailReducer',
  'RejectRegistration'
);

export const UPDATE_REGISTRATION: string = typeCreatorV2(
  'RegistrationDetailReducer',
  'UpdateRegistration'
);

export const EXCLUDE_REGISTRATION: string = typeCreatorV2(
  'RegistrationDetailReducer',
  'ExcludeRegistration'
);

export const SET_ID_TYPE: string = typeCreatorV2(
  'RegistrationDetailReducer',
  'SetVatType'
);

export const CANCEL_REGISTRATION: string = typeCreatorV2(
  'RegistrationDetailReducer',
  'CancelRegistration'
);

export const SET_APPLICANT_ACTIVE_REGISTRATIONS: string = typeCreatorV2(
  'RegistrationDetailReducer',
  'SetApplicantActiveRegistrations'
);
